import { render } from "./Blocks.vue?vue&type=template&id=13c1555e"
import script from "./Blocks.vue?vue&type=script&lang=js"
export * from "./Blocks.vue?vue&type=script&lang=js"
script.render = render

export default script